/**
 * CR150: Preview Debug Line Component
 * 
 * Displays proof-line with source, env, preset name, and uxHash.
 */

import type { PreviewSource } from "@/hooks/useLayoutPreviewSource";

interface PreviewDebugLineProps {
  source: PreviewSource;
  presetName: string | null;
  uxHash: string;
}

export function PreviewDebugLine({ source, presetName, uxHash }: PreviewDebugLineProps) {
  const sourceLabel = source === "draft" ? "draft" : "published";
  const envLabel = source === "published_staging" 
    ? "staging" 
    : source === "published_live" 
      ? "live" 
      : "—";

  return (
    <div className="font-mono text-[10px] text-muted-foreground bg-muted/30 px-2 py-1 rounded border border-dashed">
      <span>source=</span>
      <span className="text-foreground">{sourceLabel}</span>
      <span className="mx-1.5">env=</span>
      <span className="text-foreground">{envLabel}</span>
      <span className="mx-1.5">preset=</span>
      <span className="text-foreground">"{presetName || "NONE"}"</span>
      <span className="mx-1.5">uxHash=</span>
      <span className="text-primary font-semibold">{uxHash}</span>
    </div>
  );
}
